<!--
Author: zhangkun
Date: 2024-05-08
Desc: 基金转换
-->
<template>
    <div>
        <comp-title-dc back-url-name="home">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/quickTrade' }">快速交易</el-breadcrumb-item>
                <el-breadcrumb-item
                    :to="{ path: '/quickTrade', query: { tab: isChange ? '3' : '4' } }"
                >
                    {{ isChange ? "转换" : "赎回转申购" }}
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div :class="'bizcomp-change-fund bizcomp ' + className">
            <el-form
                v-show="!buySuccess"
                ref="fundInfo"
                :model="fundInfo"
                :rules="rules"
                label-width="260px"
                class="pwdForm"
                inline-message
                v-on:submit.native.prevent
            >
                <el-form-item label="转出基金：" class="form-text">
                    <div v-cloak class="text-con">
                        {{ fund.fundname + "(" + fund.fundcode + ")" }}
                    </div>
                </el-form-item>
                <el-form-item label="可用份额：" class="form-text red">
                    <div v-cloak class="text-con">
                        {{ $util.fmtNum(bankInfo.usableremainshare) }}
                        <span class="freeze">份</span>
                    </div>
                </el-form-item>
                <el-form-item label="转换渠道：" prop="transactionaccountid" class="payway-list">
                    <el-radio-group
                        v-model="fundInfo.transactionaccountid"
                        class="bank-radio"
                        vertical
                    >
                        <el-radio
                            v-for="(bank, index) in fund.fundArr"
                            :key="index"
                            :label="bank.transactionaccountid + bank.index"
                            border
                        >
                            <div class="bank-img-sel">
                                <img
                                    v-if="bank.bankcode"
                                    :src="$util.getImg(bank.bankcode)"
                                    alt=""
                                />
                                <div class="k-text-flow">
                                    <span
                                        v-cloak
                                        class="bank-name"
                                        :title="$cache.getDict('110080', bank.bankcode)"
                                    >
                                        {{
                                            $cache.getDict("110079", bank.paycenterid) +
                                            "-" +
                                            $cache.getDict("110080", bank.bankcode)
                                        }}
                                        {{
                                            bank.depositcard
                                                ? "（" + bank.depositcard.substr(-7, 7) + "）"
                                                : ""
                                        }}
                                    </span>
                                    总额(份)：
                                    <span class="bank-balance">
                                        {{ $util.fmtNum(bank.usableremainshare) }}
                                    </span>
                                </div>
                                <i class="el-icon-check" aria-hidden="true" />
                            </div>
                        </el-radio>
                    </el-radio-group>
                    <div v-if="sourceflagAllotment" class="sourceflag-tip">
                        <span class="allotment">
                            存在不可转换的代销渠道份额共{{ $util.fmtNum(sourceflagAllotment) }}份。
                        </span>
                        <span class="toDetails" v-on:click.stop="showDetail">点击查看详情>>></span>
                    </div>
                </el-form-item>
                <el-form-item label="转入基金：" prop="targetFund">
                    <el-tooltip
                        :disabled="isShowTooltip"
                        :content="targetFundInfo.fundname + '(' + targetFundInfo.fundcode + ')'"
                        placement="top"
                    >
                        <el-select
                            v-model="fundInfo.targetFund"
                            filterable
                            :remote="!isChange"
                            :remote-method="searchFund"
                            placeholder="请选择转入基金"
                            v-on:visible-change="visibleChange"
                            v-on:change="selectcode"
                            v-on:mouseover.native="spanMouseenter($event)"
                        >
                            <el-option
                                v-for="item in targetFunds"
                                :key="item.fundcode"
                                :label="item.fundname + '(' + item.fundcode + ')'"
                                :title="item.fundname + '(' + item.fundcode + ')'"
                                :value="item.fundcode"
                            >
                                {{ item.fundname + "(" + item.fundcode + ")" }}
                            </el-option>
                        </el-select>
                    </el-tooltip>
                    <!--<p v-if="targetFundInfo.fundname" class="redemp-prompt">-->
                    <!--<i class="el-icon-warning" aria-hidden="true" />预计按照{{ targetFundInfo.fundname+'&nbsp;'+$util.fmtDate(targetFundInfo.navdate) }}的单位净值买入-->
                    <!--</p>-->
                </el-form-item>
                <fund-risk-filter
                    v-show="!buySuccess"
                    :changefund="true"
                    :qryall="ismatch"
                    v-on:qry-change="qryChange"
                />
                <el-form-item
                    v-if="fundInfo.sharetype"
                    label="收费方式："
                    prop="sharetype"
                    class="form-text"
                >
                    <el-select v-model="fundInfo.sharetype" :disabled="true">
                        <el-option value="0" label="前收费"></el-option>
                        <el-option value="1" label="后收费"></el-option>
                    </el-select>
                    <el-tooltip placement="top">
                        <div slot="content">
                            前收费是在申购基金时收取申购费,
                            <br />
                            而后收费则是在申购时不收费，
                            <br />
                            在赎回时才收取手续费用。
                        </div>
                        <img src="../../assets/img/tip.png" class="w18 h18 ml12" />
                    </el-tooltip>
                </el-form-item>
                <el-form-item
                    label="转换份额："
                    prop="amount"
                    :class="{ 'form-text': !isPwdCheck && targetFundRisk.sign }"
                >
                    <el-input
                        v-model.trim="fundInfo.amount"
                        class="prefix"
                        :placeholder="pla"
                        :maxlength="14"
                        :disabled="!targetFundInfo.fundname"
                    />
                    <span
                        v-if="!isAmountAll && targetFundInfo.fundname"
                        class="redemp-btn"
                        v-on:click="allSell"
                    >
                        <span class="like-a" v-on:click="allSell">全部份额</span>
                    </span>
                </el-form-item>
                <el-form-item v-if="Number(fundInfo.amount)" label="份额确认：">
                    {{ $util.capitalShare(fundInfo.amount, "份") }}
                </el-form-item>
                <el-form-item v-if="isChange">
                    <div>
                        <div style="font-size: 16px">
                            该交易可能会产生费用，以实际交易为准
                            <span
                                style="color: var(--color-redirect); cursor: pointer"
                                v-on:click="showTips = !showTips"
                            >
                                点击详情了解计算方法
                            </span>
                        </div>
                        <div v-show="showTips">
                            <div>转换费 = 转出基金的赎回费 + 转换补差费</div>
                            <div>赎回费：{{ fund.fundname }}</div>
                            <div>赎回费的计算：</div>
                            <div>赎回总额 = 赎回份数 × 赎回基金当日基金份额净值</div>
                            <div>赎回费用 = 赎回总额 × 赎回基金赎回费率</div>
                            <div>赎回金额 = 赎回总额 - 赎回费用</div>
                            <div>转换补差费：{{ targetFundInfo.fundname }}</div>
                            <div>转换补差费的计算：</div>
                            <div>转入净额 = 转出净额 - 转换补差费</div>
                            <div>转换补差费 = 转出净额 * (转入基金申购费率 - 转出基金申购费率)</div>
                        </div>
                    </div>
                    <div v-if="$util.hasFM(fund)" class="fm-tip">
                        转出产品{{ fund.fundname }}({{
                            fund.fundcode
                        }})为浮动管理费产品，存在扣除超额管理费或返还或有管理费的可能，具体金额以实际确认为准。您可通过交易确认查询。
                    </div>
                </el-form-item>
                <!-- <el-form-item v-show="feeGate.charge" label="预估手续费：" class="form-text">
                <div class="text-con" v-html="feeH" />
            </el-form-item> -->
                <!--                <el-form-item v-if="false && Number(fundInfo.amount)" label="转换费率：">
                    <span>
                        赎回费率： {{ $util.fmtToPercent(feeGate.executionrate) }}
                    </span>
                    <span>
                        申购费率差： {{ $util.fmtToPercent(feeGate.buysubfeerate) }}
                    </span>
                </el-form-item>-->
                <el-form-item
                    v-if="isChange && Number(fundInfo.amount) && fundInfo.sharetype !== '1'"
                    label="预估转换手续费："
                >
                    <span class="charge-text">{{ $util.fmtNum(feeGate.preconvercharge) }}元</span>
                    <span class="c_999">
                        (预估赎回费{{ $util.fmtNum(feeGate.preredeemcharge) }}元 +
                    </span>
                    <span class="c_999">
                        预估转换补差费{{ $util.fmtNum(feeGate.presubconvercharge) }}元)
                    </span>
                </el-form-item>
                <el-form-item
                    v-if="isPwdCheck"
                    label="交易密码："
                    prop="pwd"
                    :class="{ 'form-text': targetFundRisk.sign }"
                >
                    <el-input
                        v-model.trim="fundInfo.pwd"
                        type="password"
                        placeholder="请输入交易密码"
                        :maxlength="20"
                    />
                    <span
                        class="redemp-btn"
                        v-on:click.prevent="$router.push({ name: 'tradepwd' })"
                    >
                        <span class="like-a">忘记密码？</span>
                    </span>
                </el-form-item>

                <el-form-item style="margin-left: -80px">
                    <div
                        v-if="readFileInfoList.length !== 0"
                        class="check-box bar-pad showChenckbox"
                        style="font-size: 14px; display: flex; align-items: flex-start"
                    >
                        <div style="display: flex; align-items: center">
                            <input v-model="checkbox" type="checkbox" class="w18 h18" />
                            <span class="check-text">我已阅读并同意:</span>
                        </div>
                        <ul>
                            <li
                                v-for="(item, index) in readFileInfoList"
                                :key="index"
                                class="flex hcenter"
                            >
                                <a
                                    class="cursor-pointer"
                                    target="_blank"
                                    v-on:click="getClick(index)"
                                >
                                    《{{ item.filename }}》
                                </a>
                            </li>
                        </ul>
                    </div>
                </el-form-item>
                <el-form-item v-if="deadlinetime" style="margin-left: -70px">
                    <div class="deadlinetime-content">
                        {{
                            "提示：我们将24小时受理您的交易申请，您交易日的交易申请至" +
                            deadlinetime +
                            "截止，" +
                            deadlinetime +
                            "以后的交易申请或非交易日的交易申请视为于下一个交易日提交。"
                        }}
                    </div>
                </el-form-item>
                <el-form-item>
                    <div style="width: 50%; margin-left: 70px">
                        <el-button class="medium back" v-on:click="$router.back()">
                            上一步
                        </el-button>
                        <el-button
                            type="primary"
                            class="medium"
                            :class="isOpen || hasProductOverview ? 'disable-btn' : 'active-btn'"
                            :disabled="isOpen || hasProductOverview"
                            :loading="isOpen"
                            v-on:click="submitInfo('fundInfo')"
                        >
                            确定
                            <span id="time"></span>
                        </el-button>
                    </div>
                </el-form-item>
            </el-form>
            <result
                v-if="buySuccess"
                :result="result"
                v-on:return-page="$router.push({ name: 'traderecord' })"
                v-on:return-login="$router.push({ name: 'home' })"
            />
            <pdf-popup
                base64
                :visible="pdfVisible"
                :need-time="needTime"
                :read-file-info-list="currentFileInfoList"
                :show-close="true"
                v-on:close="finishReading"
                v-on:cancel="cancelReading"
            ></pdf-popup>
            <fund-protocol
                v-model="protocol"
                :fund="targetFundRisk"
                :show-proto-arr="false"
                v-on:all-read="changeFund"
            />
            <fund-sdx-dialog
                :fund="sdxFundInfo"
                :sdx-dialog-visible="sdxDialogVisible"
                v-on:dialogClosed="sdxDialogClose"
                v-on:dialogContinue="sdxDialogContinue"
            ></fund-sdx-dialog>
        </div>
        <footerQuestions
            v-if="$const.warmReminderDisplay"
            :common-question="commonQuestion"
            :warning-html="warningHtml"
        ></footerQuestions>
        <buy-risk-dialog
            :visible.sync="buyRiskdialogVisible"
            :type="dialogType"
            :content="dialogContent"
            :button-text="dialogButtonText"
            v-on:confirm="handleDialogConfirm"
        />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import result from "@/components/layout/result.vue";
import fundProtocol from "@/components/form/fundProtocol";
import fundRiskFilter from "@/components/form/fundRiskFilter";
import PdfPopup from "@/components/util/pdfPopup";
import fundApi from "@/api/fund";
import footerQuestions from "@/components/layout/footerQuestions.vue";
import fundSdxDialog from "@/components/form/fundSdxDialog";
import commonApi from "@/api/common";
import buyRiskDialog from "@/components/fund/buyRiskDialog.vue";
import { sceneEnum } from "@/util/util_jfit";
import { getRiskFilter } from "@/util";

export default {
    name: "ChangeFund",
    components: {
        PdfPopup,
        result,
        fundRiskFilter,
        fundProtocol,
        footerQuestions,
        fundSdxDialog,
        buyRiskDialog
    },
    mixins: [mixin],
    data() {
        return {
            targetfundcode: "",
            feeH: "", // 费率信息
            fundInfo: {
                availablevol: "",
                amount: "",
                transactionaccountid: "",
                targetFund: "",
                sharetype: "",
                pwd: ""
                // protocol: ""
            },
            checkbox: false, // 阅读确认1
            readFileInfoList: [], // 披露文件信息
            readappno: "", // 申请单编号
            interval: "",
            ismatch: getRiskFilter(), // 适当性过滤字段
            protocol: false,
            isPwdCheck: false,
            isAmountAll: false,
            pla: "请选择转换目标基金",
            fund: {}, // 基金信息获取
            buySuccess: false, // 购买状态
            result: {
                // 结果页面信息
                cla: "register-success",
                msg: "您的基金转换申请已提交成功！",
                btnMsg: "预计确认时间：2018-11-16，如遇节假日则顺延，请耐心等待",
                special: false,
                btnL: {
                    text: "查看交易记录",
                    event: "return-page"
                },
                btnR: {
                    text: "返回我的资产",
                    event: "return-login"
                }
            },
            query: null,
            targetFunds: [], // 目标基金列表
            changeList: [], // 赎回转购时，可转换基金代码列表
            rules: {
                amount: [{ validator: this.amountLimit, trigger: "blur" }],
                sell: [
                    {
                        required: true,
                        message: "请选择取现方式",
                        trigger: "change"
                    }
                ],
                id: [
                    {
                        required: true,
                        message: "请选择取现渠道",
                        trigger: "change"
                    }
                ],
                pwd: [
                    {
                        required: true,
                        message: "请输入交易密码",
                        trigger: "blur"
                    }
                ],
                sharetype: [{ required: true, message: "请选择收费方式", trigger: "change" }]
            },
            limit: { min: "0.01", max: "0", text: "转换份额范围为：" },
            ZX_CENTER_ID: "",
            feeGate: {},
            targetFundInfo: {}, // 目标基金代码
            targetFundRisk: {}, // 目标基金适当性信息
            bankInfo: {},
            changecode: "",
            changeShareType: "",
            currentFileInfoList: [], // 当前阅读信批文件
            pdfVisible: false,
            needTime: false,
            commonQuestion: [],
            warningHtml: "",
            isChange: false, // 是否转换
            searchText: "", // 关键字搜索
            isApply: false, // 是否正在申请
            isShowTooltip: true, // 文本超长，显示tooltip
            xjbfundcode: "", // 现金宝基金代码
            isOpen: false, // 正在发起请求
            sdxFundInfo: {},
            sdxDialogVisible: false,
            deadlinetime: "",
            showTips: false,
            buyRiskdialogVisible: false, // 弹窗显示状态
            dialogType: "", // 弹窗类型（forbid/warn）
            dialogContent: "", // 弹窗文案
            dialogButtonText: "", // 按钮文案
            hasProductOverview: false, // 确定按钮
            sourceflagAllotment: "", // 代销总份额
            allNormalFunds: [],
            hasReadProductOverview: false // 是否已完整阅读产品概要
        };
    },
    watch: {
        "fundInfo.transactionaccountid"(val) {
            this.bankInfo = this.fund.fundArr.filter((item) => {
                return item.transactionaccountid + item.index === val;
            })[0];
            this.limitRefresh();
            // 切换渠道，清空检验信息
            this.$refs["fundInfo"].clearValidate();
        },
        "fundInfo.targetFund"(val) {
            this.targetFundInfo = this.targetFunds.filter((item) => {
                return item.fundcode === val;
            })[0];
            if (val !== "") {
                this.$set(
                    this.fundInfo,
                    "sharetype",
                    this.targetFundInfo.sharetype != "2"
                        ? this.targetFundInfo.sharetype
                        : this.fund.sharetype
                );
            }
            this.limitRefresh();
        },
        "fundInfo.sharetype"(val) {
            if (val === "1") {
                this.feeGate = {};
            }
        },
        "fundInfo.amount"(val) {
            this.isAmount(val);
        },
        readFileInfoList: {
            handler: function (obj) {
                if (
                    obj.length > 0 &&
                    obj.every(function (item) {
                        return item.read; // 产品概要强制阅读，其他不用
                    })
                ) {
                    this.checkbox = true;
                }
            },
            deep: true
        },
        checkbox(val) {
            if (val) {
                // 如果已经完整阅读过产品概要，则不再弹出强制阅读
                if (this.hasReadProductOverview) {
                    return;
                }

                this.currentFileInfoList = [];
                this.readFileInfoList.forEach((item) => {
                    if (item.filetype == "7") {
                        this.currentFileInfoList.push(item);
                    }
                });
                if (this.currentFileInfoList.length > 0) {
                    this.needTime = true;
                    this.pdfVisible = true;
                }
            }
            if (!val) {
                this.readFileInfoList.forEach((item) => (item.read = false));
            }
        }
    },
    mounted() {
        this.isChange = this.$route.name == "changefund";
        const info = this.$cache.getUser();
        let xjbFundInfo = JSON.parse(sessionStorage.getItem("xjbFundInfo"));
        this.xjbfundcode = xjbFundInfo.fundcode;
        this.ismatch = info.ismatch || "1";
        if (this.isChange) {
            this.commonQuestion = this.$const.commonQuestion.commonQuestion4;
        }
        this.fund = JSON.parse(sessionStorage.getItem(this.$route.name));
        if (this.fund.fundArr.length > 0) {
            this.calculateTotal();
            if (this.xjbfundcode == this.fund.fundcode) {
                this.fund.fundArr = this.fund.fundArr.filter((item) => {
                    return item.transtype === "0";
                });
            } else {
                this.fund.fundArr = this.fund.fundArr.filter((item) => {
                    return item.sourceflag === "1";
                });
            }
        }
        // this.fund.fundArr = this.fund.fundArr.filter((item) => {
        //     return (
        //         item.paycenterid != this.$util.getConfig().const.ZX_CENTER &&
        //         item.paycenterid != "0001"
        //     );
        // });

        // 检查过滤后是否还有可用数据
        if (this.fund.fundArr.length === 0) {
            this.$message.error("可赎回转申购的份额为0");
            this.$router.back();
            return;
        }

        this.initFundInfo();
    },
    methods: {
        // 选择目标基金
        selectcode(data) {
            // 清空检验信息
            this.$refs["fundInfo"].clearValidate();
            this.changecode = data;
            this.changeShareType = this.fundInfo.sharetype;
            this.getFileInfo();
            if (!this.isChange && this.searchText.length) {
                this.searchText = "";
                // this.getNormalFundList();
                this.filterFunds();
            }
        },
        // 文本太长显示不全，则显示Tooltip
        spanMouseenter(e) {
            let target = e.target;
            if (target.clientWidth < target.scrollWidth) {
                this.isShowTooltip = false;
            } else {
                this.isShowTooltip = true;
            }
        },
        // 获取披露文件信息
        async getFileInfo() {
            if (this.changecode === "") {
                return;
            }
            this.readFileInfoList = [];
            const selectShareType = this.targetFunds.filter((item) => {
                return item.fundcode === this.changecode;
            })[0].sharetype;
            const targetFundsInfo = this.targetFunds.filter((item) => {
                return item.fundcode === this.changecode;
            })[0];
            const fundRes = await fundApi.getFundLists({
                keyword: this.changecode,
                pagesize: "20",
                pagenum: "1"
            });
            let targetFundshowtype = "";
            if (fundRes) {
                targetFundshowtype = fundRes.data.list[0].fundshowtype;
            }
            this.$util.queryReadFileInfo(
                {
                    fundcode: this.changecode,
                    sharetype: selectShareType,
                    filetype: "",
                    scene: this.isChange ? sceneEnum.change : sceneEnum.sellToBuy,
                    fundshowtype: targetFundshowtype
                },
                (res) => {
                    res.forEach((item) => {
                        item.read = false;
                        if (item.filetype.trim() === "7") {
                            // 产品概要
                            this.readFileInfoList.unshift(item);
                        } else {
                            this.readFileInfoList.push(item);
                        }
                    });

                    // 此逻辑只针对公募基金
                    if (targetFundsInfo && targetFundsInfo.fundclass == "0") {
                        this.$util.isFundTypeValid(targetFundsInfo).then((flag) => {
                            if (!flag) {
                                // 是否有配置产品概要书
                                let obj = this.readFileInfoList.find(
                                    (item) => item.filetype.trim() === "7"
                                );
                                this.hasProductOverview = !obj;
                                if (this.hasProductOverview) {
                                    this.$message.error(
                                        "协议获取失败，暂时无法交易。如有疑问，请联系客服处理。"
                                    );
                                }
                            } else {
                                this.hasProductOverview = false;
                            }
                        });
                    } else {
                        this.hasProductOverview = false;
                    }
                },
                true
            );
        },
        // 获取链接点击事件
        getClick(index) {
            this.currentFileInfoList = [this.readFileInfoList[index]];
            this.readFileInfoList[index].read = true;
            if (this.currentFileInfoList[0].filetype === "7") {
                this.needTime = true;
            } else {
                this.needTime = false;
            }
            this.pdfVisible = true;
        },
        finishReading() {
            this.pdfVisible = false;
            // 如果阅读的是产品概要（filetype === "7"），标记为已完整阅读
            if (this.currentFileInfoList[0] && this.currentFileInfoList[0].filetype === "7") {
                this.hasReadProductOverview = true;
            }
        },
        cancelReading() {
            this.checkbox = false;
            this.pdfVisible = false;
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo(formName) {
            this.sdxFundInfo = {};
            if (this.isApply) {
                return;
            }
            if (this.readFileInfoList.length !== 0) {
                if (!this.checkbox) {
                    return this.$alert(
                        "根据相关法规要求，请在交易前仔细阅读相关文件，并勾选“同意”选项。",
                        "提示",
                        { confirmButtonText: "确定" }
                    );
                }
                commonApi.fundFileLeaveTracesLog(this, this.readFileInfoList);
            }
            this.isApply = true;
            setTimeout(() => {
                this.isApply = false;
            }, 3000);
            // 获取留痕申请编号
            const _this = this;
            this.$util.writeFileInfo(
                {
                    readFileInfoList: _this.readFileInfoList,
                    fundcode: _this.fund.fundcode,
                    tano: _this.fund.tano
                },
                (res) => {
                    _this.readappno = res;
                    _this.$refs[formName].validate((valid) => {
                        if (valid) {
                            const proto = _this.isChange ? "change" : "sellToBuy";
                            _this.$util.getSdxProtocol(
                                {
                                    fundcode: _this.targetFundInfo.fundcode,
                                    fundshowtype: _this.targetFundInfo.fundshowtype,
                                    proto: proto
                                },
                                (res) => {
                                    // 开了购买前校验开关才用
                                    if (this.$util.buyVerificationOpen()) {
                                        this.$util
                                            .checkComplianceService(this.targetFundInfo.fundcode)
                                            .then((checkRes) => {
                                                if (checkRes.dialogType) {
                                                    this.dialogButtonText =
                                                        checkRes.dialogButtonText;
                                                    this.dialogType = checkRes.dialogType;
                                                    this.dialogContent = checkRes.dialogContent;
                                                    this.buyRiskdialogVisible = true;
                                                } else {
                                                    this.sdxDialogVisible = true;
                                                }
                                                _this.targetFundRisk = res;
                                                this.sdxFundInfo = res;
                                            });
                                    } else {
                                        this.sdxDialogVisible = true;
                                        this.sdxFundInfo = res;
                                        _this.targetFundRisk = res;
                                    }
                                }
                            );
                        } else {
                            _this.$errorScroll();
                        }
                    });
                }
            );
        },
        // 处理弹窗确认事件（按钮点击）
        handleDialogConfirm() {
            commonApi.commonLeaveTracesLog(this, {
                eventid: this.$const.RECORD.before_purchasing_verification,
                eventname: `购买前校验确定按钮`,
                content: JSON.stringify(
                    Object.assign({
                        name: "高龄客户",
                        dialogContent: this.dialogContent,
                        dialogButtonText: this.dialogButtonText
                    })
                )
            });
            // 根据弹窗类型执行不同操作
            if (this.dialogType === "warn") {
                this.sdxDialogVisible = true;
            }
        },
        sdxDialogClose() {
            this.sdxDialogVisible = false;
        },
        sdxDialogContinue() {
            this.sdxDialogVisible = false;
            this.protocol = true;
        },
        // 改变风险过滤规则
        qryChange(val) {
            this.ismatch = val;
            this.initFundInfo();
        },
        // 发起转换或赎回转申购
        async changeFund(val) {
            this.protocol = false;
            if (!val) return;
            const _this = this;
            if (_this.readFileInfoList.length > 0 && _this.readappno.length === 0) {
                this.isApply = false;
                return this.$alert("没有留痕申请编号,操作失败 请联系客服");
            }
            this.isOpen = true;
            try {
                let res = null;
                if (this.isChange) {
                    res = await fundApi.tradeConvert({
                        fundcode: _this.bankInfo.fundcode,
                        contractno: _this.readappno,
                        readappno: _this.readappno,
                        sharetype: _this.bankInfo.sharetype,
                        transactionaccountid: _this.bankInfo.transactionaccountid,
                        targetfundcode: _this.targetFundInfo.fundcode,
                        targetsharetype: _this.fundInfo.sharetype,
                        applicationvol: _this.fundInfo.amount,
                        tradepassword: this.isPwdCheck ? this.$util.enc(_this.fundInfo.pwd) : null,
                        oldercustriskflag: this.dialogType == "warn" ? "1" : "",
                        buyflag: this.sdxFundInfo.riskmismatchflag == "1" ? "1" : "2",
                        riskwarnflag: this.sdxFundInfo.riskwarnflag == "1" ? "1" : "2",
                        highriskwarnflag: this.sdxFundInfo.highriskwarnflag == "1" ? "1" : "2"
                    });
                } else {
                    if (_this.fund.assetshowtype == "1") {
                        // 现金宝产品走实时TA赎回转购
                        res = await fundApi.combTransRealtaRedeemForBuy({
                            transactionaccountid: this.bankInfo.transactionaccountid,
                            tradepassword: this.$util.enc(this.fundInfo.pwd),
                            applicationvol: this.fundInfo.amount,
                            targetfundcode: this.targetFundInfo.fundcode,
                            targetsharetype: this.fundInfo.sharetype,
                            contractno: _this.readappno,
                            readappno: _this.readappno,
                            redeemmode: "5",
                            largeredemptionflag: "0",
                            oldercustriskflag: this.dialogType == "warn" ? "1" : "",
                            buyflag: this.sdxFundInfo.riskmismatchflag == "1" ? "1" : "2",
                            riskwarnflag: this.sdxFundInfo.riskwarnflag == "1" ? "1" : "2",
                            highriskwarnflag: this.sdxFundInfo.highriskwarnflag == "1" ? "1" : "2"
                        });
                    } else {
                        res = await fundApi.combTransRedeemForBuy({
                            fundcode: _this.bankInfo.fundcode,
                            contractno: _this.readappno,
                            readappno: _this.readappno,
                            sharetype: _this.bankInfo.sharetype,
                            transactionaccountid: _this.bankInfo.transactionaccountid,
                            targetfundcode: _this.targetFundInfo.fundcode,
                            targetsharetype: _this.fundInfo.sharetype,
                            applicationvol: _this.fundInfo.amount,
                            tradepassword: this.isPwdCheck
                                ? this.$util.enc(_this.fundInfo.pwd)
                                : null,
                            redeemmode: "0",
                            largeredemptionflag: "0",
                            oldercustriskflag: this.dialogType == "warn" ? "1" : "",
                            buyflag: this.sdxFundInfo.riskmismatchflag == "1" ? "1" : "2",
                            riskwarnflag: this.sdxFundInfo.riskwarnflag == "1" ? "1" : "2",
                            highriskwarnflag: this.sdxFundInfo.highriskwarnflag == "1" ? "1" : "2"
                        });
                    }
                }
                if (res.data) {
                    this.result.cla = "register-success";
                    const date = this.isChange ? res.data.cfmdate : res.data.transactioncfmdate;
                    this.result.btnMsg =
                        "预计确认：" + this.$util.fmtDate(date) + "， 如遇节假日则顺延";
                } else {
                    this.result.cla = "register-fail";
                    this.result.btnMsg = "原因：" + res.msg;
                }
                const prefix = this.isChange ? "您的转换申请已提交" : "您的赎回转申购申请已提交";
                this.result.msg = prefix + (this.result.cla === "register-fail" ? "失败" : "成功");
                this.buySuccess = true;
            } catch (e) {
                this.$log.error(e);
            } finally {
                this.isOpen = false;
            }
        },
        // 全部取现处理
        allSell() {
            this.fundInfo.amount = Number(this.bankInfo.usableremainshare) + "";
            this.$refs.fundInfo.validateField("amount");
            this.isAmountAll = true;
        },
        // 处理金额
        isAmount(val) {
            const _val = this.$util.checkAmount(val);
            clearTimeout(this.query);
            this.query = setTimeout(() => {
                this.$set(this.fundInfo, "amount", _val);

                if (Number(this.fundInfo.amount) === this.bankInfo.usableremainshare) {
                    this.isAmountAll = true;
                } else {
                    this.isAmountAll = false;
                }
                this.queryRate();
            }, 1);
        },
        // 费率入参获取
        queryRate() {
            const _this = this;
            let _d = null;
            const info = this.$cache.getUser();
            if (
                this.fundInfo.amount > 0 &&
                this.fundInfo.sharetype === "0" &&
                this.bankInfo.channelid &&
                this.targetFundInfo.fundcode &&
                this.isChange
            ) {
                _d = {
                    fundcode: this.fund.fundcode,
                    applicationvol: this.fundInfo.amount,
                    channelid: this.bankInfo.channelid,
                    bizcode: this.targetFundInfo.isconvert === "0" ? "8" : "7",
                    targetfundcode: this.targetFundInfo.fundcode,
                    targetsharetype: this.fundInfo.sharetype,
                    businesscode: "36",
                    transactionaccountid: this.bankInfo.transactionaccountid
                };
            }
            this.$util.getFee(_d, (res) => {
                _this.feeGate = res;
                _this.feeH =
                    '<span class="red">' +
                    _this.$util.fmtNum(_this.feeGate.charge) +
                    "元</span>(<s>" +
                    _this.$util.fmtNum(_this.feeGate.originfee) +
                    '</s>元，为您节省<span class="red">' +
                    _this.$util.fmtNum(_this.feeGate.discount) +
                    "</span>元)";
            });
        },
        amountLimit(rule, value, callback) {
            rule.mes = this.isChange ? "转换份额" : "赎回转申购份额";
            this.$util.validateAmountLimit(this, rule, value, callback);
        },
        // 查询目标基金
        initFundInfo() {
            const info = this.$cache.getUser();
            if (info.ismatch != this.ismatch) {
                info.ismatch = this.ismatch;
                this.$store.dispatch("setInfo", info);
            }
            this.getChangeFundList();
            this.getDeadline();
            this.$set(
                this.fundInfo,
                "transactionaccountid",
                this.fund.fundArr[0].transactionaccountid + this.fund.fundArr[0].index
            );
            this.$set(this.fundInfo, "availablevol", this.fund.fundArr[0].usableremainshare);
        },
        // 赎回转申购，下拉列表消失，重新请求接口
        visibleChange(val) {
            if (!val) {
                // this.searchFund("");
                this.searchText = "";
                // 转换页面不需要重新过滤，因为 targetFunds 已经有数据
                // 赎回转申购页面需要重新过滤以恢复完整列表
                if (!this.isChange) {
                    this.filterFunds();
                }
            }
        },
        // 关键词搜索基金
        searchFund(val) {
            if (!this.isChange) {
                // 赎回转申购
                this.searchText = val;
                // this.getNormalFundList();
                this.filterFunds();
            }
        },
        // 过滤基金 (只用于赎回转申购页面)
        filterFunds() {
            // 转换页面的 targetFunds 由 getChangeFundList 和 enrichTargetFundInfo 直接处理
            // 只有赎回转申购页面才需要使用 allNormalFunds 进行过滤
            let array = this.allNormalFunds;
            if (this.searchText.trim()) {
                const keyword = this.searchText.trim();
                array = array.filter(
                    (item) =>
                        item.fundcode.indexOf(keyword) > -1 ||
                        item.fundname.indexOf(keyword) > -1 ||
                        (item.fundpinyin &&
                            item.fundpinyin.toUpperCase().indexOf(keyword.toUpperCase()) > -1)
                );
            }

            this.targetFunds = array.filter((item) => {
                if (!item || !item.fundcode) return false;
                if (item.fundcode == this.fund.fundcode) return false;
                if (this.fund.assetshowtype != "1" && this.changeList.indexOf(item.fundcode) > -1) {
                    return false;
                }
                return true;
            });

            let xjbFundInfo = JSON.parse(sessionStorage.getItem("xjbFundInfo"));
            this.targetFunds = this.targetFunds.filter((item) => {
                return item.fundcode !== xjbFundInfo.fundcode;
            });
        },
        // 查询可转换基金
        async getChangeFundList() {
            const res = await fundApi.queryTradeConvertInfo({
                qryallfund: this.isChange ? this.ismatch : "0",
                fundcode: this.fund.fundcode,
                sharetype: this.fund.sharetype
            });
            if (res.data) {
                const list = res.data ? res.data : [];
                if (this.isChange) {
                    this.targetFunds = list;
                    // 批量获取目标基金详细信息，包含 fundshowtype 和 tradingmethod 字段
                    this.$nextTick(() => this.enrichTargetFundInfo(list));
                } else {
                    this.changeList = [];
                    list.forEach((item) => {
                        this.changeList.push(item.fundcode);
                    });
                    this.getNormalFundList();
                }
            }
        },
        // 批量获取目标基金详细信息
        async enrichTargetFundInfo(fundList) {
            if (!fundList || fundList.length === 0) return;

            // 获取基金代码列表
            const fundCodeList = fundList.map((item) => item.fundcode);

            // 批量获取基金详细信息，包括 fundshowtype 和 tradingmethod 字段
            const fundDetailRes = await fundApi.getFundLists({
                fundcodelist: fundCodeList,
                fundclass: "*",
                pagesize: fundList.length,
                pagenum: 1
            });

            if (fundDetailRes.data && fundDetailRes.data.list) {
                // 创建基金代码到详细信息的映射
                const fundDetailMap = {};
                fundDetailRes.data.list.forEach((detail) => {
                    fundDetailMap[detail.fundcode] = detail;
                });

                // 合并 fundshowtype 和 tradingmethod 字段到目标基金列表
                this.targetFunds = this.targetFunds.map((fund) => {
                    return Object.assign({}, fund, {
                        fundshowtype: fundDetailMap[fund.fundcode].fundshowtype || "",
                        tradingmethod: fundDetailMap[fund.fundcode].tradingmethod || ""
                    });
                });

                // 过滤掉不能网上交易的专户基金（fundshowtype=8）
                this.targetFunds = this.targetFunds.filter((fund) => {
                    if (fund.fundshowtype !== "8") return true;
                    // 专户基金需要允许网上交易才能作为转换目标
                    return !(
                        this.$util.isEmpty(fund.tradingmethod) ||
                        fund.tradingmethod.indexOf(this.$util.getConfig().systemtype) < 0
                    );
                });
            }
        },
        // 查询截止时间
        async getDeadline() {
            const res = await fundApi.getFundLists({
                fundcode: this.fund.fundcode,
                pagesize: 100,
                pagenum: 1
            });
            if (res.data && res.data.list && res.data.list.length > 0) {
                this.deadlinetime = this.$util.transactionDatePrompt(res.data.list[0]);
            }
        },
        // 查询全量基金 过滤支持转换、不能申购的基金，现金宝转购普通产品调用实时ta赎回转购，只过滤不能申购的基金
        async getNormalFundList() {
            const info = this.$cache.getUser() || {};
            const custno = info.custno || info.custNo || info.customerno || info.customerNo || "";

            const fallbackChannel =
                (this.fund &&
                    this.fund.fundArr &&
                    this.fund.fundArr.length > 0 &&
                    this.fund.fundArr[0]) ||
                {};

            const res = await fundApi.combQueryTransRedeemForBuyList({
                fundcode: this.fund.fundcode,
                custno: custno,
                transactionaccountid:
                    this.bankInfo.transactionaccountid ||
                    fallbackChannel.transactionaccountid ||
                    "",
                qryallfund: this.ismatch, // 判断是否用户勾选适当性过滤
                businesscode: "022",
                redeemmode: this.fund.assetshowtype == "1" ? "5" : "0",
                paychannel: this.bankInfo.paycenterid || fallbackChannel.paycenterid || "0001",
                keyword: "",
                shareclass: this.fund.sharetype
            });
            if (res.data) {
                let array = res.data.datalist ? res.data.datalist : [];
                // 获取基金代码列表
                const fundCodeList = array.map((item) => item.fundcode);
                // 批量获取基金详细信息，包括tradingmethod字段
                if (fundCodeList) {
                    const fundDetailRes = await fundApi.getFundLists({
                        fundcodelist: fundCodeList,
                        fundclass: "*",
                        pagesize: array.length,
                        pagenum: 1
                    });
                    if (fundDetailRes.data && fundDetailRes.data.list) {
                        // 过滤掉不能网上交易的专户基金（fundshowtype=8）
                        const filteredList = fundDetailRes.data.list.filter((fund) => {
                            if (fund.fundshowtype !== "8") return true;
                            // 专户基金需要允许网上交易才能作为转换目标
                            return !(
                                this.$util.isEmpty(fund.tradingmethod) ||
                                fund.tradingmethod.indexOf(this.$util.getConfig().systemtype) < 0
                            );
                        });

                        this.allNormalFunds = filteredList;
                        this.filterFunds();
                    }
                } else {
                    this.allNormalFunds = [];
                    this.filterFunds();
                }
            }
        },
        // 获取目标基金适当性信息
        getTargetRisk(_code) {
            const _this = this;
            if (_code) {
                this.$util.fundRiskCheck(
                    _this,
                    { fundcode: _code, proto: "convert" },
                    function (data) {
                        _this.targetFundRisk = data;
                    }
                );
            }
        },
        // 获取限额
        async limitRefresh() {
            const type = this.isChange ? "转换" : "赎回转申购";
            if (this.bankInfo.usableremainshare == 0) {
                this.$set(this.limit, "max", 0);
                this.$set(this.limit, "min", 0);
                this.pla = `可用份额为0，无法${type}`;
                return;
            }
            if (this.bankInfo.channelid && this.targetFundInfo.fundcode) {
                this.queryRate();
                this.getTargetRisk(this.targetFundInfo.fundcode);
                const code = this.isChange ? "036" : "099";
                this.$util.queryValidPwdTrdMethod(code, (res) => {
                    this.isPwdCheck = res;
                });
                let res = null;
                //  && !(this.xjbfundcode == this.bankInfo.fundcode && this.fund.transtype == "1")
                if (this.isChange) {
                    res = await fundApi.combQueryTargetFundLimit({
                        fundcode: this.fund.fundcode,
                        sharetype: this.fund.sharetype,
                        targetfundcode: this.targetFundInfo.fundcode,
                        targetsharetype: this.fundInfo.sharetype
                    });
                } else {
                    res = await fundApi.combTransRedeemForBuyLimit({
                        fundcode: this.fund.fundcode,
                        sharetype: this.fund.sharetype,
                        targetfundcode: this.targetFundInfo.fundcode,
                        targetsharetype: this.fundInfo.sharetype,
                        transactionaccountid: this.bankInfo.transactionaccountid
                    });
                }
                if (res.data && res.data.datalist) {
                    const limit = res.data.datalist.find((item) => {
                        return item.transactionaccountid == this.bankInfo.transactionaccountid;
                    });
                    if (!limit) {
                        return;
                    }
                    const _max =
                        Number(this.bankInfo.usableremainshare) > Number(limit.max)
                            ? limit.max
                            : this.bankInfo.usableremainshare;
                    this.$set(this.limit, "max", _max);
                    if (this.$util.fmtNum(limit.min) - 0 >= this.$util.fmtNum(_max) - 0) {
                        this.$set(this.limit, "min", _max);
                        this.pla = `本次${type}只能全额转换`;
                    } else {
                        this.$set(this.limit, "min", limit.min);
                        this.pla =
                            `本次${type}范围为` +
                            this.$util.fmtNum(limit.min) +
                            "-" +
                            this.$util.fmtNum(_max) +
                            "份";
                    }
                    if (this.fundInfo.amount) {
                        this.$refs.fundInfo.validateField("amount");
                    }
                }
            } else {
                this.pla = `请选择${type}目标基金`;
            }
        },
        // 跳转到资产详情页
        showDetail() {
            this.$router.push("/assetsDetail");
        },
        // 计算总份额
        calculateTotal() {
            // 使用 reduce 方法安全计算总和
            this.sourceflagAllotment = this.fund.fundArr
                .filter((item) => {
                    return item.sourceflag === "2";
                })
                .reduce((sum, item) => {
                    // 确保值存在且为数字类型
                    const value = parseFloat(item.usableremainshare) || 0;
                    return sum + value;
                }, 0);
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.bizcomp-change-fund {
    .comp-fund-risk-filter {
        padding: 0 20px;
    }
    .el-radio-group.bank-radio .el-radio {
        // margin-top: 10px;
    }
    .back {
        color: var(--color-text-regular);
        background: var(--color-divided);
        border-color: transparent;
    }
    .active-btn {
        background: var(--color-primary);
    }
    .disable-btn {
        background: var(--color-primary);
        opacity: 0.4;
    }
    .bank-img-sel {
        box-sizing: border-box;
        width: 550px !important;
    }
    .check-text {
        padding-left: 5px;
        color: var(--color-text-primary);
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .fm-tip {
        line-height: 20px;
        margin-right: 200px;
        color: var(--color-primary);
    }
}
.deadlinetime-content {
    color: var(--color-text-regular);
    width: 550px;
    line-height: 20px;
}
</style>

<style lang="scss" scope>
.sourceflag-tip {
    display: flex;
    align-items: center;
    .allotment {
        color: var(--color-primary);
    }
    .toDetails {
        cursor: pointer;
        color: var(--color-redirect);
    }
}
.charge-text {
    color: var(--color-primary);
}
</style>
